



















































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTopicSubject from '@/components/GTopicSubject.vue';
import { masterModule } from '@/store/modules/entities/master.module';
import { customCompetencyModule } from '@/store/modules/frames/custom-competency.module';
import { Competency, CreateCustomCompetency, CompetencySelection, CustomCompetency, CustomCompetencyBoxplot } from '@/models/competency/competency';
import GLoading from '@/components/GLoading.vue';
import { required } from 'vuelidate/lib/validators';
import GVTag from '@/components/GVTag.vue';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GOptionalIcon from '@/components/GOptionalIcon.vue';

@Component({
  name: 'GCustomBoxplotSetting',
  components: {
    GVTag,
    GLoading,
    GTitleBar,
    GTopicSubject,
    GCustomBreadCrumb,
    GCompetencyLabel,
    GOptionalIcon,
  },
  computed: {},
  methods: {},
  validations: {
    selected: { required },
  },
})
export default class GCustomBoxplotSetting extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  listColumn: object[] = [];
  lazy: boolean = false;
  size: number = 24;
  isUpdate: boolean = false;
  selected: number[] = [];
  processing: boolean = false;

  async mounted() {
    await masterModule.fetchCompetency();
    customCompetencyModule.clean();
    await customCompetencyModule.fetchCustomCompetency();
    await customCompetencyModule.fetchCustomCompetencyBoxplot().then((data: CustomCompetencyBoxplot) => {
      // 取得した「箱ひげ図設定済み学校コンピテンシーID」を回し、現在登録されている学校コンピテンシーと照合
      // 存在していて、かつ、isValid な学校コンピテンシーIDのみを「選択済み」とする
      this.selected = data.competencyIDs.filter((id: number) => {
        const customCompe = customCompetencyModule.customCompetencies.find((cc: CustomCompetency) => cc.isValid && cc.id === id);
        if (customCompe) {
          return id;
        }
      });
    });

    this.breadCrumbItems = [
      {
        title: this.$t('HOME').toString(),
        icon: 'ios-home',
        routerPath: '/pages/home',
      },
      { title: this.$t('BOXPLOT_ADDITIONAL_SETTING').toString() },
    ];
    this.createColumn();
    this.lazy = true;
  }

  /**
   * 新規作成実行
   */
  handleCommit() {
    this.processing = true;
    customCompetencyModule.addUpdateCustomCompetencyBoxplot(this.selected).then(() => {
      this.showInsertSuccessed();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    });
  }

  get competencyMap(): Map<number, Competency> {
    return masterModule.competencyMap;
  }

  get isNonCompetencySelected(): boolean {
    return this.selected.length === 0;
  }

  get isValid(): boolean {
    return !this.isNonCompetencySelected;
  }

  get customCompetencies() {
    return customCompetencyModule.customCompetencies;
  }

  get isProcessing(): boolean {
    return this.processing;
  }

  rowDisableColor(row: CustomCompetency): string {
    if (!row.isValid) {
      return 'invalid-row';
    }
    return 'no-setting-row';
  }

  createColumn(): void {
    this.listColumn = [this.columnActions, this.columnCustomCompetencyName, this.columnCompetencies];
  }

  get columnCustomCompetencyName(): any {
    return {
      title: this.$t('DISPLAY_LABEL').toString(),
      key: 'name',
      width: 320,
    };
  }

  get columnCompetencies(): any {
    return {
      title: this.$t('USE_COMPETENCY').toString(),
      slot: 'selected-competency',
    };
  }

  get columnActions(): any {
    return {
      title: this.$t('SELECT').toString(),
      slot: 'actions',
      align: 'center',
      width: 60,
    };
  }
}
